export const notFullWarningTextDefault = 'Проверьте и заполните недостающие поля';
export const checkWarningTextDefault =
    'Проверьте, что введённые данные совпадают с\u00A0паспортными';

export const eventToThreeFields = {
    event: 'gtm_non_interaction_event',
    action: 'View',
    block: 'Заявка на кредит наличными',
    label_detail: 'ФИО в 3 поля',
};

export const DEFAULT_MAX_LENGTH = 35;
